var _g, _g2, _g3, _g4, _g5, _g6, _g7, _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOfCreditBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 852,
    viewBox: "0 0 393 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 357,
    cy: 105,
    r: 60,
    fill: "#804FBF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 311,
    r: 83,
    fill: "#575A9C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 662,
    r: 96,
    fill: "#0048FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 812,
    r: 96,
    fill: "#0048FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 486,
    r: 60,
    fill: "#575A9C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 43,
    r: 55,
    fill: "#1364FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_15202_3016)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 797,
    r: 48,
    fill: "#1364FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 580.5,
    r: 6.5,
    fill: "#FFB8DD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 682.5,
    r: 3.65625,
    fill: "#E0E9FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.656,
    cy: 542.656,
    r: 8.22656,
    fill: "#FFCE99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15202_3016",
    x: 114.648,
    y: -137.352,
    width: 484.704,
    height: 484.704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.176,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_15202_3016",
    x: -251,
    y: -22,
    width: 666,
    height: 666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_15202_3016",
    x: 8,
    y: 316,
    width: 692,
    height: 692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_15202_3016",
    x: -272,
    y: 466,
    width: 692,
    height: 692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_15202_3016",
    x: -101,
    y: 176,
    width: 620,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_15202_3016",
    x: -196.352,
    y: -194.352,
    width: 474.704,
    height: 474.704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.176,
    result: "effect1_foregroundBlur_15202_3016"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_15202_3016",
    x: -33.352,
    y: 566.648,
    width: 460.704,
    height: 460.704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 91.176,
    result: "effect1_foregroundBlur_15202_3016"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfCreditBg);
export default __webpack_public_path__ + "static/media/out-of-credit-bg.5f3654456020a99c890e446f2532f55f.svg";
export { ForwardRef as ReactComponent };